module.exports = __webpack_public_path__ + "media/custom/images/img7-0b1ba0f423ec7874d472a70c4ff31aa7.png";